/**
 * Polish plural form for a count: "1 linia", "2 linie", "5 linii" — few for 2–4
 * except the teens, many otherwise.
 */
export function plural(count: number, one: string, few: string, many: string): string {
  if (count === 1) {
    return one;
  }

  const lastDigit = count % 10;
  const lastTwo = count % 100;

  if (lastDigit >= 2 && lastDigit <= 4 && !(lastTwo >= 12 && lastTwo <= 14)) {
    return few;
  }

  return many;
}
